import { create } from 'zustand'

// Lodash
import _ from 'lodash';

const useStore = create((set) => ({
    set: (path, value) =>
        set((state) => {
            const newState = _.cloneDeep(state);

            const isObject = typeof value === 'object' && !Array.isArray(value) && value !== null;

            if (!isObject || Object.keys(value).length === 0) {
                // If not a plain object, or is an empty object ({}), assign directly
                _.set(newState, path, value);
            } else {
                // Deep merge only for objects with properties
                const current = _.get(newState, path, {});
                const merged = _.merge({}, current, value);
                _.set(newState, path, merged);
            }

            return newState;
        }),
}));

export default useStore;